import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccIntRate = () => {
  const response = useBondsBondFieldApi('S_ACC.INT_RATE');
  return response;
};
